import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useProjects } from '../hooks/useProjects'

function isStaff(email: string | null | undefined): boolean {
  return Boolean(email && email.endsWith('@llamassist.ai'))
}

export function ProjectRedirect() {
  const { user, loading: authLoading } = useAuth()
  const { projects, loading: projectsLoading } = useProjects()

  if (authLoading || projectsLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="w-8 h-8 border-4 border-brand-500 border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  // LlamAssist staff always lands on the admin queue
  if (isStaff(user?.email)) {
    return <Navigate to="/admin" replace />
  }

  // Clients with no projects yet
  if (projects.length === 0) {
    return (
      <div className="text-center py-20">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">No projects found</h2>
        <p className="text-gray-500 text-sm">
          You don't have access to any projects yet. Contact your project administrator.
        </p>
      </div>
    )
  }

  return <Navigate to={`/${projects[0].short_uuid}`} replace />
}
